/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2022
 *
 *==================================================
 */
export const GENERIC = "GENERIC";
export const GUEST = "GUEST";
export const REGISTERED = "REGISTERED";
